import { Skeleton } from '../ui/skeleton';

const CohortSkeleton = () => {
    return (
        <div className="flex flex-col gap-4">
            {[...Array(5)].map((_, i) => (
                <div key={i}>
                    <div className="flex items-center gap-4 p-4 bg-neutral-100 rounded-lg">
                        {Array(5)
                            .fill(null)
                            .map((_, index) => (
                                <div key={index} className="flex-1">
                                    <Skeleton className="h-4 w-1/4" />
                                </div>
                            ))}
                    </div>
                </div>
            ))}
        </div>
    );
};
export default CohortSkeleton;
